import classNames from 'classnames';
import React, { ReactNode } from 'react';

const defaultAlignmentClasses = {
  right: 'tw-left-unset -tw-right-2 tw-translate-x-0 after:tw-right-[.5em]',
  center:
    'tw-left-1/2 -tw-translate-x-1/2 tw-right-unset after:tw-left-1/2 after:-tw-translate-x-1/2',
  left: '-tw-left-2 tw-right-unset tw-translate-x-0 after:tw-left-[.5em]',
};
const smAlignmentClasses = {
  right: 'sm:tw-left-unset sm:-tw-right-2 sm:tw-translate-x-0 sm:after:tw-right-[.5em]',
  center:
    'sm:tw-left-1/2 sm:-tw-translate-x-1/2 sm:tw-right-unset sm:after:tw-left-1/2 sm:after:-tw-translate-x-1/2',
  left: 'sm:-tw-left-2 sm:tw-right-unset sm:tw-translate-x-0 sm:after:tw-left-[.5em]',
};
const mdAlignmentClasses = {
  right: 'md:tw-left-unset md:-tw-right-2 md:tw-translate-x-0 md:after:tw-right-[.5em]',
  center:
    'md:tw-left-1/2 md:-tw-translate-x-1/2 md:tw-right-unset md:after:tw-left-1/2 md:after:-tw-translate-x-1/2',
  left: 'md:-tw-left-2 md:tw-right-unset md:tw-translate-x-0 md:after:tw-left-[.5em]',
};

export type Alignment = 'right' | 'center' | 'left';
// if more screen sizes are added to this in the future the appropriate classes need to be
// added in /style.css. This is outside tailwind so the prefixes have to be manually setup.
export type ScreenSize = 'default' | 'sm' | 'md';
export type ResponseAlignment = Partial<Record<ScreenSize, Alignment>>;
interface TooltipProps {
  visible: boolean;
  children: ReactNode;
  className?: string;
  alignment?: ResponseAlignment;
  below?: boolean;
}

const Tooltip = ({
  children,
  className,
  visible,
  below = false,
  alignment = {
    default: 'right',
    sm: 'left',
    md: 'center',
  },
}: TooltipProps) => {
  return (
    <span
      className={classNames(
        className,
        `tw-absolute tw-block tw-max-w-[300px] tw-w-max tw-rounded lg:tw-w-max tw-transform tw-transition-opacity tw-duration-200 tw-shadow tw-z-10
        after:tw-content-[''] after:tw-absolute after:tw-w-0 after:tw-h-0 after:tw-border-[.5em] after:tw-border-transparent`,
        visible ? 'tw-opacity-100' : 'tw-opacity-0 tw-pointer-events-none',
        defaultAlignmentClasses[alignment.default ?? 'left'],
        smAlignmentClasses[alignment.sm ?? 'center'],
        mdAlignmentClasses[alignment.md ?? 'center'],
        below
          ? 'tw-top-full tw-mt-2 after:tw-top-[-1em]'
          : 'tw-bottom-full tw-mb-2 after:tw-top-full',
      )}
    >
      <span
        className={classNames(
          className,
          `tw-block tw-relative tw-text-xs lg:tw-text-sm tw-py-1 tw-px-4 lg:tw-px-4 tw-text-center tw-rounded-md`,
        )}
      >
        {children}
      </span>
    </span>
  );
};
export default Tooltip;
